import { pathname } from "./PathName";

/**
 * A URL segment can carry a name rather than a slug — a client is linked to by
 * its company name, which may hold spaces or an "&". `pathname` decodes with
 * decodeURI, which leaves reserved characters escaped, so the segment is
 * decoded here first. A malformed escape is left alone rather than thrown over.
 */
export const decodeSegment = (segment) => {
	try {
		return decodeURIComponent(segment);
	} catch (error) {
		return segment;
	}
};

/**
 * Routes that end in a record id have nothing readable in the URL, so the page
 * that links there passes a name in navigation state and the page itself
 * resolves one when it is opened from a pasted link. This is where that name is
 * read, which is why the breadcrumb, the page heading and the browser tab all
 * show the same thing.
 *
 * `location` is the react-router location; only the last segment of the current
 * path is ever replaced by a state name, the rest are mapped through the usual
 * slug table.
 */
export const routeSegmentLabel = (segment, location) => {
	const segments = (location?.pathname || "").split("/").filter(Boolean);
	const lastSegment = segments[segments.length - 1];
	const isLastSegment =
		lastSegment !== undefined &&
		decodeSegment(String(segment)) === decodeSegment(lastSegment);

	if (
		isLastSegment &&
		location?.pathname?.includes("/externalusers/sub-user/") &&
		location?.state?.subUserName
	) {
		return location.state.subUserName;
	}

	return pathname(decodeSegment(segment));
};
